import { TextField, TextFieldProps } from "@mui/material";
import React, { forwardRef } from "react";

type DropdownProps = TextFieldProps & {
  value: string | number;
  helperText?: string;
  error?: boolean;
  children: React.ReactNode;
};

export const Dropdown = forwardRef<HTMLInputElement, DropdownProps>(
  ({ value, helperText, error, children, ...args }, ref) => {
    return (
      <TextField
        value={value}
        select // tell TextField to render select
        variant="outlined"
        ref={ref}
        SelectProps={{
          displayEmpty: true,
          MenuProps: {
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left"
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left"
            }
          }
        }}
        helperText={helperText ?? ""}
        error={error}
        {...args}
      >
        {children}
      </TextField>
    );
  }
);

Dropdown.displayName = "Dropdown";
